<template>
  <div class="home">
    <h3>AV图文配置</h3>
    <el-button type="warning" size="mini" @click="openAddImage">图片上传</el-button>
    &nbsp;&nbsp;&nbsp;
    <el-button type="success" size="mini" @click="getEditorData">预览页面</el-button>
    &nbsp;&nbsp;&nbsp;
    <el-button type="danger" size="mini" @click="cleanData">清除数据</el-button>
    <br/><br/>
    <div id="wangEditor" class="wangEditor"></div>
    <!-- <h3>内容预览</h3> -->
    <!-- <textarea name="" id="" cols="170" rows="20" readonly v-model="editorData"></textarea> -->
    <!--预览-->
    <look ref="look"></look>
    <!--上传图片-->
    <add-image ref="addImage"></add-image>
  </div>
</template>

<script>

// 引入 wangEditor
import wangEditor from 'wangeditor'
import Look from './components/look'
import AddImage from './components/addImage'

export default {
  data() {
    return {
      editor: null,
      editorData: '',
      id: '',
      graphic: '',
    }
  },
  components: {
    Look,
    AddImage,
  },
  created() {
    this.id = this.$route.params.id
    this.graphic = this.$route.params.graphic
  },
  mounted() {
    const editor = new wangEditor(`#wangEditor`)
    // 配置 onchange 回调函数，将数据同步到 vue 中
    editor.config.onchange = (newHtml) => {
       this.editorData = newHtml
    }
    // 创建编辑器
    editor.create()
    if (this.graphic != '' && this.graphic != ""){
      editor.txt.html(this.graphic);
    }
    this.editor = editor
  },
  methods: {
    getEditorData() {
      // 通过代码获取编辑器内容
      let data = this.editor.txt.html()
      this.$refs.look.open(data, this.id)
    },
    openAddImage() {
      this.$refs.addImage.open()
    },
    cleanData(){
      this.id = ''
      this.graphic = ''
      this.editor.txt.html('')
    }
  },
  beforeDestroy() {
    this.cleanData()
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy()
    this.editor = null
  }
}
</script>

<style lang="scss">
  .home {
    width: 100%;
    height: 100%;
    margin: auto;
    position: relative;
    .btn {
      position: absolute;
      right: 0;
      top: 0;
      padding: 5px 10px;
      cursor: pointer;
    }
    .btn1 {
      padding: 5px 10px;
    }
    h3 {
      margin: 30px 0 15px;
    }
    .w-e-text-container{
      height: 700px !important;
    }
    .wangEditor{
      z-index: 1 !important;
      width: 100%;
      position: absolute;
    }
  }
</style>
